import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import type { ContentTab, DialogTabSaveContext } from '@/v2/framework/dialog/types'
import { createInheritableTabSave } from '@/v2/kits/tenant-inheritance'
import {
  displayIdRowFields,
  tournamentDefaultEventSelectionOptions,
  tournamentGamesStatusOptions,
} from '../../../../shared'
import { notifySuccess, tournamentRoundId } from '../shared'

const liveTabChildren: ContentTab['children'] = [
  {
    type: 'group',
    name: 'liveGame',
    label: '',
    children: [
      {
        type: 'select-field',
        name: 'status',
        label: 'Status',
        required: true,
        placeholder: 'Select status',
        options: tournamentGamesStatusOptions,
        inheritance: {
          computedKey: 'computedStatus',
          parentKey: 'parentStatus',
        },
      },
      {
        type: 'text-field',
        name: 'position',
        label: 'Position',
        placeholder: 'Enter position',
        inheritance: {
          computedKey: 'computedPosition',
          parentKey: 'parentPosition',
        },
      },
      {
        type: 'structured-array-field',
        name: 'displayIds',
        label: 'Display IDs',
        minItems: 0,
        maxItems: 50,
        inheritance: {
          computedKey: 'computedDisplayIds',
          parentKey: 'parentDisplayIds',
        },
        children: displayIdRowFields,
      },
      {
        type: 'select-field',
        name: 'defaultEventSelection',
        label: 'Default Event Selection',
        placeholder: 'Select default event selection for live game',
        required: true,
        options: tournamentDefaultEventSelectionOptions,
        inheritance: {
          computedKey: 'defaultEventSelection',
          parentKey: 'parentDefaultEventSelection',
        },
      },
    ],
  },
]

export function createLiveTab(roundsApi: TournamentRoundsApi): ContentTab {
  const save = createInheritableTabSave({
    children: liveTabChildren,
    persist: async (patch, ctx: DialogTabSaveContext) => {
      await roundsApi.update(tournamentRoundId(ctx.values), patch)
      notifySuccess()
    },
  })

  return {
    id: 'live',
    label: 'Live',
    save,
    children: liveTabChildren,
  }
}
